import dateComparator from "./DateComparator";
import filterParams from "./DateFilter";

export const columnDefs = [
  {
    headerName: "Num",
    valueGetter: "node.rowIndex + 1",
    width: 90,
    suppressSizeToFit: false,
    checkboxSelection: true,
    minWidth: 90,
    maxWidth: 90,
  },
  {
    headerName: "Date de céation",
    field: "date_creationLisible",
    filter: "date_creationLisible",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    hide: true,
  },
  {
    headerName: "Date de céation1",
    field: "date_creation",
    filter: "date_creation",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    hide: true,
  },
  {
    // floatingFilter: true,
    headerName: "Date de péremption",
    field: "date_peromptionLisible",
    filter: "date_peromptionLisible",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    // hide: true,
    // hide: true,
    // cellClass: (params) => {
    //   let ID = sessionStorage.getItem("ID_PriseEnCharge");
    //   // eslint-disable-next-line
    //   if (params?.data?.idPriseEnCharge == ID) {
    //     return "aggridGoBackStyles";
    //   } else {
    //     return "null";
    //   }
    // },
  },
  {
    // floatingFilter: true,
    headerName: "Date de péremption1",
    field: "date_peromption",
    filter: "date_peromption",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    hide: true,
    // hide: true,
    // cellClass: (params) => {
    //   let ID = sessionStorage.getItem("ID_PriseEnCharge");
    //   // eslint-disable-next-line
    //   if (params?.data?.idPriseEnCharge == ID) {
    //     return "aggridGoBackStyles";
    //   } else {
    //     return "null";
    //   }
    // },
  },
  {
    headerName: "Date de modification",
    field: "updated_at",
    hide: true,
  },
  {
    headerName: "Produit",
    field: "nom_Produits_Frs",

  },
  {
    headerName: "Fk_id_Prod_Frs",
    field: "Fk_id_Prod_Frs",
    hide: true,
  },
  {
    headerName: "idStock_Produits",
    field: "idStock_Produits",
    hide: true,
  },
  {
    headerName: "fk_id_Frs",
    field: "fk_id_Frs",
    hide: true,
  },


  // {
  //   headerName: "daysAgo",
  //   field: "daysAgo",
  //   hide: true,
  // },
  {
    floatingFilter: true,
    headerName: "Prix",
    field: "prix",
    // cellClass: (params) => {
    //   let duration = params.data.daysAgo;
    //   let done = params.data.done;

    //   let result = "";
    //   if (duration > 120 && done === 0) {
    //     result = "classNegative";
    //   } else if (duration > 90 && done === 0) {
    //     result = "classWarning";
    //   }
    //   return result;
    // },
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Quantité",
    field: "quantiteFix",
    // cellClass: (params) => {
    //   let duration = params.data.daysAgo;
    //   let done = params.data.done;

    //   let result = "";
    //   if (duration > 120 && done === 0) {
    //     result = "classNegative";
    //   } else if (duration > 90 && done === 0) {
    //     result = "classWarning";
    //   }
    //   return result;
    // },
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Consommation",
    field: "consommation",
    // hide: true,
  },
  {
    headerName: "Reste",
    field: "reste",
    cellClass: (params) => {
      let reste = params.data.reste
      let enCours = params.data.enCours
      // let terminee = params.data.terminee

      let result = "";
      if (reste < 6 && enCours == 1) {
        result = "classNegative";
      } else if (reste < 20 && enCours == 1) {
        result = "classWarning";
      } else if (reste < 0 && enCours == 1) {
        result = "classNegative";
      }
      else if (reste > 20 && enCours == 1) {
        result = "paidFooter"
      }
      return result;
    },
    // hide: true,
  },

  {
    headerName: "enCours",
    field: "enCours",
    hide: true,
  },
  {
    headerName: "terminee",
    field: "terminee",
    hide: true,
  },
  {
    headerName: "archive",
    field: "archive",
    hide: true,
  },

  {
    floatingFilter: true,
    headerName: "Fournisseur",
    field: "nom_frs",
    hide: true,
  },
];
export const columnDefsFRS2 = [
  // {
  //   headerName: "Num",
  //   valueGetter: "node.rowIndex + 1",
  //   width: 90,
  //   suppressSizeToFit: false,
  //   checkboxSelection: true,
  //   minWidth: 90,
  //   maxWidth: 90,
  // },
  {
    // floatingFilter: true,
    headerName: "idProduits_Fournisseurs",
    field: "idProduits_Fournisseurs",
    hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Produit",
    field: "nom_Produits_Frs",
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "fk_id_Frs",
    field: "fk_id_Frs",
    hide: true,
  }
];
export const columnDefsFRS = [
  // {
  //   headerName: "Num",
  //   valueGetter: "node.rowIndex + 1",
  //   width: 90,
  //   suppressSizeToFit: false,
  //   checkboxSelection: true,
  //   minWidth: 90,
  //   maxWidth: 90,
  // },
  {
    // floatingFilter: true,
    headerName: "id_frs",
    field: "id_frs",
    hide: true,
    // suppressSizeToFit: true,
  },
  {
    checkboxSelection: true,
    floatingFilter: true,
    headerName: "Fournisseurs",
    field: "nom_frs",
    minWidth: 200,
    maxWidth: 500,
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Tel",
    field: "tel_frs",
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Tel2",
    field: "tel_frs2",
    // hide: true,
  },
];
export const columnDefs2 = [
  {
    headerName: "date_consultation_For_Server",
    field: "date_consultation_For_Server",
    hide: true,
  },
  {
    headerName: "Total du :",
    field: "total",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "date consultation",
    field: "date_consultation",
  },
  {
    headerName: "gain latent",
    field: "gain_latent",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "montant total",
    field: "sum_act",
    cellClass: (params) => (params.value > 0 ? "gain_latent" : null),
  },
  {
    headerName: "Payment_titre",
    field: "payment_titre",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "payment",
    field: "payment",
    cellClass: (params) =>
      params.value === 0
        ? "unpaidFooter"
        : params.value > 0
          ? "paidFooter"
          : null,
  },
  {
    headerName: "reste_a_payer_titre",
    field: "reste_a_payer_titre",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "reste a payer",
    field: "rest",
    cellStyle: { textAlign: "center" },
    // cellClass: (params) =>
    //   params.value === 0
    //     ? "paidFooter"
    //     : params.value > 0
    //     ? "unpaidFooter"
    //     : params.value < 0
    //     ? "overPaidFooter"
    //     : null,
  },
  // {
  //   headerName: "Numero",
  //   valueGetter: "node.rowIndex + 1",
  //   width: 90,
  //   suppressSizeToFit: false,
  //   checkboxSelection: true,
  //   minWidth: 90,
  //   maxWidth: 90,
  // },
];

// export const defaultColDef = {
//   sortable: true,
//   flex: 1,
//   // filter stuff
//   filter: true,
//   floatingFilter: true,
//   suppressMenu: true,
//   // end of filter stuff
//   minWidth: 100,
//   resizable: true,
//   filterParams: {
//     newRowsAction: "keep",
//   },
// };

export const topOptions = {
  alignedGrids: [],
  defaultColDef: {
    suppressMovable: true,
    sortable: true,
    flex: 1,
    // filter stuff
    filter: true,
    cellStyle: { textAlign: "center" },
    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
  suppressHorizontalScroll: true,
};
export const OptionsFRS2 = {
  defaultColDef: {
    suppressMovable: true,
    sortable: true,
    editable: true,
    flex: 1,
    // filter stuff
    filter: true,
    cellStyle: { textAlign: "center" },
    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
  suppressHorizontalScroll: true,
};
export const OptionsFRS = {
  defaultColDef: {
    suppressMovable: true,
    sortable: true,
    editable: true,
    flex: 1,
    // filter stuff
    filter: true,
    cellStyle: { textAlign: "center" },
    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
  suppressHorizontalScroll: true,
};

export const bottomOptions = {
  alignedGrids: [],
  defaultColDef: {
    sortable: true,
    flex: 1,
    // filter stuff
    filter: true,
    floatingFilter: true,
    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
};
